<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.name"
              placeholder="请输入用户名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.phone"
              placeholder="请输入用户电话"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.unionId"
              placeholder="请输入用户微信ID"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @dealSystem="handDealFun(arguments,0)"
        @dealL="handDealFun(arguments,1)"
        @dealC="handDealFun(arguments,2)"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
      />
    </div>
    <!-- 查看-->
    <view-dialog
      :data-id="id"
      :event-type="'view'"
      :dialog-title="'查看明细'"
      :dialog-visible.sync="dialogViewVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 查看
import viewDialog from './components/viewDialog'
// 数据请求
import { loadAppConsumerScanCigaretteCaseErrorLogListDataApi, loadAppConsumerScanCigaretteCaseErrorLogExportDataApi, saveOrUpdateAppConsumerScanCigaretteCaseErrorLogApi } from '@/api/appConsumerScanCigaretteCaseErrorLog'

export default {
  name: 'AppConsumerScanCigaretteCaseErrorLog',
  components: {
    CustomTable,
    TableOperation,
    viewDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'app_consumer_scan_cigarette_case_error_log_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['app_user_scan_cigarette_case_error_log_check'],
            prop: 'deal',
            label: '添加扫码积分(验真系统)',
            method: 'dealSystem'
          },
          {
            permissionSigns: ['app_user_scan_cigarette_case_error_log_check'],
            prop: 'deal',
            label: '添加扫码积分(流金印象)',
            method: 'dealL'
          },
          {
            permissionSigns: ['app_user_scan_cigarette_case_error_log_check'],
            prop: 'deal',
            label: '添加扫码积分(小重九)',
            method: 'dealC'
          },
          {
            permissionSigns: ['app_user_scan_cigarette_case_error_log_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['app_user_scan_cigarette_case_error_log_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            name: '',
            phone: '',
            unionId: ''
          }
        }
      },
      id: null,
      dialogViewVisible: false
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'unionId', filterColumn: 'r.union_id', label: '微信统一ID', width: 260 },
      { prop: 'provinceName', filterColumn: 'r.province_name', label: '省区', width: 120 },
      { prop: 'name', filterColumn: 'r.name', label: '名称', width: 120 },
      { prop: 'phoneStr', filterColumn: 'r.phone', filterValue: 'phone', label: '电话', width: 120 },
      { prop: 'address', filterColumn: 'r.address', label: '地址', width: 160 },
      { prop: 'scanResult', filterColumn: 'i.scan_result', label: '扫码内容', width: 260 },
      { prop: 'scanPrefix', filterColumn: 'i.scan_prefix', label: '扫码内容前缀', width: 260 },
      { prop: 'scanCode', filterColumn: 'i.scan_code', label: '扫码内容验证码', width: 260 },
      { prop: 'resultData', filterColumn: 'i.result_data', label: '扫码错误结果', width: 300 },
      { prop: 'promoterUnionId', filterColumn: 'IFNULL(u.union_id, \'\')', label: '推荐零售户ID', width: 180 },
      { prop: 'promoterStoreName', filterColumn: 'IFNULL(u.store_name, \'\')', label: '推荐零售户', width: 160 },
      { prop: 'isDealStr', filterColumn: 'i.is_deal', filterValue: 'isDeal', label: '是否手工处理', width: 140, filterArray: [{ label: '是', value: 1 }, { label: '否', value: 0 }] },
      { prop: 'dealTimeStr', filterColumn: 'i.deal_time', label: '处理时间', width: 160, isBetween: true },
      { prop: 'createTimeStr', filterColumn: 'i.create_time', label: '扫码时间', width: 160, isBetween: true }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadAppConsumerScanCigaretteCaseErrorLogListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.dialogViewVisible = !this.dialogViewVisible
    },
    // 手工处理
    handDealFun (args, sort) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].isDeal !== 0) {
        this.$message({
          message: '数据已手工处理，不能操作',
          type: 'warning'
        })
        return
      }
      let sortStr = ''
      if (sort === 1) {
        sortStr = '流金印象'
      } else if (sort === 2) {
        sortStr = '小重九'
      }
      this.$confirm('是否确定手工处理添加' + sortStr + '扫码积分？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateAppConsumerScanCigaretteCaseErrorLogApi({ id: args[0].id, dealData: "1", sort: sort }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadAppConsumerScanCigaretteCaseErrorLogExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
